// helpers/showToast.js
import { toast } from "react-toastify";

export const showToast = (message, type = "success", extra = {}) => {
  const options = {
    containerId: "global", // ← important: matches ToastifyClient.jsx
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    theme: "dark",
    ...extra,
  };

  switch (type) {
    case "success":
      return toast.success(message, options);
    case "error":
      return toast.error(message, options);
    case "warning":
      return toast.warning(message, options);
    default:
      return toast.info(message, options);
  }
};
